export const calculatePercentage = (part, total) => {
  if (total === 0) {
    return 0;
  }
  const percentage = (part / total) * 100;
  // Round to two decimal places
  return Math.round(percentage * 100) / 100;
};

export const formatDecimal = (value, decimalPlaces = 2) => {
  if (value === null || value === undefined) {
    return value;
  }

  if (typeof value !== 'number') {
    value = parseFloat(value);
  }

  return value.toFixed(decimalPlaces);
};
